export const DRAFT = 'draft'
export const FAILED = 'failed'
export const PENDING = 'pending'
export const VERIFYING = 'verifying'
export const SUCCESS = 'success'
export const WAIT_FOR_APPROVE = 'wait_for_approve'
